// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import Rails from "@rails/ujs"

// Start Rails UJS to enable data-confirm behavior
Rails.start()
